module.exports = __webpack_public_path__ + "img/flowers-7910753_1280.81f9256d.png";